import React from 'react';
import {withCookies} from 'react-cookie';
import _ from 'lodash';
import Nav from '../../../shared/components/nav';
import SiteHead from '../../../shared/components/header';
import {Redirect} from "react-router-dom";
import {getNotice, removeNotice} from "../../AuthWrapper/actions";
import {sendMessage, joinChatRoom, onNewUser, eventOnReconnect, getNumberOfUnreadMessages, eventOnMessage, eventOnRead, leaveChatRoom, eventOnJoin, onConnect, getMessagesRequest, readMessage} from "../../Chat/actions";
import {connect} from "react-redux";
import Notice from "../../../components/Notification/newNotification";
import SoundNotification from '../../../components/NotificationSound';
import AdminChatBox from '../../../components/Chat/adminChatBox';
import CalendarView from "../../../components/CalendarView/CalendarView";
import Spinner from "../../../components/Spinner";
import EditPasswordForm from "../../../components/Profile/editPasswordForm";


class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMenuOpened: false,
            navMini: false,
            userLoaded: false,
            hasNotification: false,
            connected: props.chatData.adminIsOnline,
            isMinimized: true,
            isScrolledToBottom: true,
            isCalendarClosed: true,
            isChangePasswordModalOpened: false
        }
        this.handleClickSend = this.handleClickSend.bind(this);
        this.handleReadMessage = this.handleReadMessage.bind(this);
        this.resetHasNotification = this.resetHasNotification.bind(this);
    }

    toggleNav = (e) => {
        //e.preventDefault();
        this.setState({navMini: !this.state.navMini});
    };

    toggleMenu = (e) => {
        this.setState({menuIsOpened: !this.state.menuIsOpened});
    }


    hideNav = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.setState({navMini: false})
    };

    onLogoutClick() {
        this.props.onLogout();
    }

    componentDidMount() {
        this.changeUserLoaded(this.props);
        this.props.getNotice();
        this.props.onConnect();
        this.noticeInterval = setInterval(() => this.props.getNotice(), 7000);
    }

    componentWillUnmount() {
        clearInterval(this.noticeInterval);
    }

    componentWillReceiveProps (nextProps) {
        this.changeUserLoaded(nextProps)
        if (this.props.auth.isUnAuthorized !== nextProps.auth.isUnAuthorized && nextProps.auth.isUnAuthorized) {
            return <Redirect to="/sign-in" />
        }
        if(!this.props.auth.isUnAuthorized && !_.isEqual(this.props.chatData.messages, nextProps.chatData.messages)) {
            this.props.getNumberOfUnreadMessages();
        }
        if(nextProps.chatData.error && !this.props.chatData.error) {
            Notice.addNotification(nextProps.chatData.error, 'error');
        }
        if(this.props.chatData.numberOfMessages < nextProps.chatData.numberOfMessages) {
            this.setState({hasNotification: true});
        }
        if(this.props.chatData.adminIsOnline !== nextProps.chatData.adminIsOnline) {
            const cookies = this.props.cookies;
            cookies.set('adminIsOnline', nextProps.chatData.adminIsOnline, { path: '/' });
        }
        if(!this.props.chatData.connected && nextProps.chatData.connected) {
            const cookies = this.props.cookies;
            const adminIsOnline = cookies.get('adminIsOnline');
            if(adminIsOnline !== 'false') {
                this.props.joinChatRoom();
                this.props.getNumberOfUnreadMessages();
                this.props.eventOnJoin();
                this.props.eventOnMessage();
                this.props.eventOnReconnect();
                this.props.eventOnNewUser();
            }
        }
    }
    handleClickSend(message) {
        this.props.sendMessage({message, toUserId: 1});
    }
    handleReadMessage(messageId) {
        this.props.readMessage(messageId);
    }
    seeNotice (data, userData) {
        this.props.seeNotice(data, userData);
    }

    changeUserLoaded (propState) {
        if (propState.auth.isCurrentUserLoadingSuccess) {
            this.setState({
                userLoaded: true
            })
        }
    }

    resetHasNotification() {
        this.setState({hasNotification: false});
    }

    toggleMinimizedState = () => {
        this.setState({isMinimized: !this.state.isMinimized});
    };
    readMessages = () => {
        const unreadMessage = this.props.chatData.messages.filter(message => {
            if (!message.is_read && message.to === this.props.auth.currentUser.id) {
                return message.id
            }
        });
        if (unreadMessage && unreadMessage[unreadMessage.length - 1]) {
            this.handleReadMessage(unreadMessage[unreadMessage.length - 1].id)
        }
    };
    handleScroll = (element) => {
        this.setState({isScrolledToBottom: element.scrollHeight === Math.ceil(element.offsetHeight + element.scrollTop) || element.scrollHeight === Math.floor(element.offsetHeight + element.scrollTop)});
    };

    scrollToBottom = (element) => {
        if (element) {
            element.scrollTop = element.scrollHeight;
        }
    };
    addNewMessage = (message, selectedUser) => {
        let messageToSend = message.replace(/\n/g, '\\n').replace(/\s/g, '\\s');
        if (message && selectedUser && message.replace(/\s/g, '').length && message.replace(/\n/g, '').length) {
            this.props.sendMessage({message: messageToSend, toUserId: selectedUser});
            this.setState({message: ''});
        }
    };

    toggleEditPasswordModal = (isChangePasswordModalOpened = true) => {
        this.setState({ isChangePasswordModalOpened });
    }

    render() {
        if(this.props.auth.userLoading || this.props.auth.userLoading === undefined) {
           return <Spinner />;
        }
        if(!this.props.auth.currentUser && this.props.auth.loggedIn !== true) {
            return <Redirect to="/sign-in" />
        } else if (this.props.auth.currentUser.role === 'user') {
            return <Redirect to="/account" />
        }
        let navMini = this.state.navMini;
        const isMenuOpened = this.state.menuIsOpened;

        const setChatClosed = () => {
            this.setState({isMinimized:true});
        }

        const changeCalendarState = (value = true) => {
            this.setState({isCalendarClosed: value});
        }

        return (
            <div>
                <CalendarView
                    openCalendarView={this.openCalendarView}
                    isChatClosed={this.state.isMinimized}
                    isCalendarClosed={this.state.isCalendarClosed}
                    changeCalendarState={changeCalendarState}
                    setChatClosed={setChatClosed}
                />
                <AdminChatBox
                    changeCalendarState={changeCalendarState}
                    isCalendarClosed={this.state.isCalendarClosed}
                    isMinimized={this.state.isMinimized}
                    onlineUsers= {this.props.chatData.onlineUsers}
                    toggleMinimizedState={this.toggleMinimizedState}
                    getNumberOfUnreadMessages={this.props.getNumberOfUnreadMessages}
                    getMessages={this.props.getMessages}
                    handleReadMessage={this.handleReadMessage}
                    handleKeyPress={this.handleKeyPress}
                    isSingleChat={true}
                    readMessages = {this.readMessages}
                    handleScroll={this.handleScroll}
                    scrollToBottom={this.scrollToBottom}
                    addNewMessage= {this.addNewMessage}
                    currentUser={this.props.auth.currentUser}
                    adminIsOnline={this.props.chatData.adminIsOnline}
                    sendMessage={this.handleClickSend}
                    messages={this.props.chatData.messages}
                    numberOfMessages={this.props.chatData.numberOfMessages}
                    noMoreMessages={this.props.chatData.noMoreMessages}
                    loadingMessages={this.props.chatData.loadingMessages}
                    addedMessage={this.props.chatData.addedMessage}
                    isScrolledToBottom={this.state.isScrolledToBottom}
                />
                <div className="app-wrapper">
                    <Nav mini={navMini} toggleMenu={this.toggleMenu} toggleNav={this.toggleNav} isMenuOpened={isMenuOpened}/>
                    <div className={`content-container ${navMini ? 'full' ? isMenuOpened && 'big_header' : '' : ''}`}>
                        <div className="menu-dropshadow" style={{display: (navMini ? 'block' : 'none')}} onClick={this.hideNav}></div>
                        <SiteHead
                            numberOfMessages={this.props.chatData.numberOfMessages}
                            role={this.props.auth.currentUser.role}
                            toggleNav={this.toggleNav}
                            onLogoutClick={this.onLogoutClick.bind(this)}
                            noticesForUsers={this.props.auth.notices.noticesForUsers}
                            noticesForUsersCount={this.props.auth.notices.noticesForUsersCount}
                            notices={this.props.auth.notices.notices}
                            noticeCount={this.props.auth.notices.noticeCount}
                            onSeeNotice={this.seeNotice.bind(this)}
                            removeNotice={this.props.removeNotice}
                            currentUser={this.props.auth.currentUser}
                            openChangePasswordModal={this.toggleEditPasswordModal}
                        />
                        {this.props.children}
                    </div>
                    <SoundNotification resetHasNotification={this.resetHasNotification} hasNotification={this.state.hasNotification}/>
                </div>
                <EditPasswordForm
                    isModalOpened={this.state.isChangePasswordModalOpened}
                    closeModal={() => this.toggleEditPasswordModal(false)}
                />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    chatData: state.chatData
});

const mapDispatchToProps = dispatch => {
    return {
        getNotice: () => dispatch(getNotice()),
        joinChatRoom: () => dispatch(joinChatRoom()),
        getNumberOfUnreadMessages: () => dispatch(getNumberOfUnreadMessages()),
        eventOnMessage: () => dispatch(eventOnMessage()),
        eventOnJoin: () => dispatch(eventOnJoin()),
        eventOnRead: () => dispatch(eventOnRead()),
        leaveChatRoom: () => dispatch(leaveChatRoom()),
        eventOnReconnect: () => dispatch(eventOnReconnect()),
        onConnect: () => dispatch(onConnect()),
        eventOnNewUser: () => dispatch(onNewUser()),
        getMessages: (partnerId, page) => dispatch(getMessagesRequest(partnerId, page)),
        sendMessage: (data) => dispatch(sendMessage(data)),
        readMessage: (messageId) => dispatch(readMessage(messageId)),
        removeNotice: (data) => dispatch(removeNotice(data)),
    }
};

export default withCookies(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/index.js